/// <reference types="@types/google.maps" />

// declare module 'googlemaps';

import { InjectionToken } from '@angular/core';
import { AddressComponentsJson } from '@vmspdb/definitions';
import { Observable } from 'rxjs';

export const GOOGLE_MAPS = new InjectionToken<GoogleMapsServiceInterface>(
  'GOOGLE_MAPS',
);

export interface PlaceResult {
  fullText: string;
  components: AddressComponentsJson[];
}

export interface GoogleMapsServiceInterface {
  readonly loaded$: Observable<boolean>;
  readonly clusterLoaded$: Observable<boolean>;

  autocomplete(
    address: string,
  ): Observable<google.maps.places.PlacePrediction[]>;

  getPlace(place: google.maps.places.PlacePrediction): Observable<PlaceResult>;

  geocode(request: google.maps.GeocoderRequest): Observable<PlaceResult>;
}
